module.exports = __webpack_public_path__ + "static/media/GothamRnd-Medium.c379f598.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Medium.woff
 ** module id = 1355
 ** module chunks = 0
 **/